import React from 'react'
import { Circle } from '@mui/icons-material'
import { getNodeId, Instance } from 'mobx-state-tree'
import styled from '@emotion/styled'

import { Question } from '@trivie/core'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'
import { useMediaQuery } from '@mui/material'
import { observer } from 'mobx-react-lite'

export const QuestionImportSidebar = observer((props: any) => {
  const { questions, onSelectionChange } = props

  const mobile = useMediaQuery('(max-width:900px)')

  return (
    <div style={ROOT}>
      <div style={CONTAINER}>
        <DrawerHeader />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={SIDEBAR_HEADER}>
            <Text variant="body1Emphasized" style={{ color: color.shade80 }}>
              Questions
            </Text>
          </div>
          {(questions ?? ([] as Array<Instance<typeof Question>>))
            .filter((q) => !q.removing)
            .map((q) => (
              <div
                onClick={() => {
                  onSelectionChange(q)
                }}
                className="sidebar-question"
                key={getNodeId(q)}
                style={{
                  ...QUESTION_ROW,

                  background: q.selected
                    ? 'linear-gradient(81.39deg, #E4EBFF -188.61%, #ECE9FF 93.43%)'
                    : 'none',
                }}
              >
                <div style={QUESTION_ROW_CONTAINER}>
                  <div style={QUESTION_ROW_CONTENT}>
                    <div style={QUESTION_ROW_TEXT}>
                      <Text
                        style={{
                          ...QUESTION_TEXT,
                          fontStyle: q.new && !q.text ? 'italic' : 'normal',
                          display: mobile ? '-webkit-box' : 'block',
                        }}
                        text={q.new && !q.text ? 'Empty Question' : q.text ?? ' '}
                      />
                    </div>
                    {q?.approved ? (
                      <Circle
                        style={{ fontSize: 8, alignSelf: 'center' }}
                        htmlColor={color.green}
                      />
                    ) : q?.allErrors.length && q?.touched ? (
                      <Circle htmlColor={color.red} style={{ fontSize: 8, alignSelf: 'center' }} />
                    ) : (q?.allWarnings.length || !q?.approved) && q?.touched ? (
                      <Circle
                        htmlColor={color.yellow}
                        style={{ fontSize: 8, alignSelf: 'center' }}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
})

const DrawerHeader = styled('div')(({ theme }: any) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
  minHeight: '70px !important',
}))

const ROOT: React.CSSProperties = {
  background: '#F8FAFD',
  borderRight: `1px solid ${color.shade5}`,
  maxWidth: 340,
  minWidth: 340,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}
const QUESTION_ROW: React.CSSProperties = {
  position: 'relative',
  cursor: 'pointer',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 16,
  paddingRight: 16,
  paddingLeft: 24,
  borderBottom: `1px solid #EFF0F6`,
  backgroundColor: '#F8FAFD',
  display: 'flex',
  minHeight: 50,
}
const QUESTION_ROW_CONTAINER: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}
const QUESTION_TEXT: React.CSSProperties = {
  textAlign: 'left',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '17px',
  overflowWrap: 'break-word',
  userSelect: 'none',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  maxWidth: 228,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingRight: 12,
}
const QUESTION_ROW_CONTENT: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  position: 'relative',
  justifyContent: 'space-between',
}
const QUESTION_ROW_TEXT: React.CSSProperties = { display: 'flex' }
const CONTAINER: React.CSSProperties = { flex: 1, overflowY: 'auto' }
const SIDEBAR_HEADER: React.CSSProperties = {
  paddingLeft: 24,
  paddingRight: 24,
  paddingTop: 24,
  paddingBottom: 24,
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid #EFF0F6`,
}
